export default __webpack_public_path__ + "static/media/coin-bag-solid--dark.b9b74873.svg";